import classNames from 'classnames/bind';
import styles from './NewsCard.module.scss';
import Img from '~/component/Img';
import { FaClock, FaLocationArrow } from 'react-icons/fa';
import images from '~/assets';
import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import useOnScreen2 from '~/hooks/useOnScreen2';
import useOnScreen from '~/hooks/useOnScreen';

const cx = classNames.bind(styles);

const ICTU_IMAGES = [
  {
    image: 'https://ngogiaquyen.id.vn/assets/ictu/1.jpg',
    tag: 'Lễ khai giảng',
  },
  {
    image: 'https://ngogiaquyen.id.vn/assets/ictu/2.jpg',
    tag: 'Giảng đường C5',
  },
  {
    image: 'https://ngogiaquyen.id.vn/assets/ictu/3.jpg',
    tag: 'Sân bóng',
  },
  {
    image: 'https://ngogiaquyen.id.vn/assets/ictu/4.jpg',
    tag: 'Giảng đường C5 về đêm',
  },
  {
    image: 'https://ngogiaquyen.id.vn/assets/ictu/5.jpg',
    tag: 'Lễ khai giảng',
  },
  {
    image: 'https://ngogiaquyen.id.vn/assets/ictu/6.jpg',
    tag: 'Giảng đường C2',
  },
  {
    image: 'https://ngogiaquyen.id.vn/assets/ictu/7.jpg',
    tag: 'Giảng đường C2',
  },
  {
    image: 'https://ngogiaquyen.id.vn/assets/ictu/8.jpg',
    tag: 'ICTU Concert',
  },
  {
    image: 'https://ngogiaquyen.id.vn/assets/ictu/9.jpg',
    tag: 'Giảng đường C1',
  },
];

function NewsCard() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const ref = useRef(null);
  const isOnScreen = useOnScreen(ref);
  const content = `Là sinh viên năm 3 tại Trường Đại học Công nghệ Thông tin và Truyền thông – Đại học Thái Nguyên, tôi đã có những trải nghiệm học tập và rèn luyện đáng nhớ. Không chỉ là nơi truyền đạt kiến thức chuyên ngành, ngôi trường còn giúp tôi khám phá bản thân, phát triển tư duy logic và kỹ năng mềm thông qua nhiều hoạt động học thuật và ngoại khóa. Đây là nơi đã nuôi dưỡng niềm đam mê công nghệ trong tôi ngày một lớn hơn.`;

  const [text, setText] = useState('');
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index < content.length) {
      const timeout = setTimeout(() => {
        setText((prev) => prev + content.charAt(index));
        setIndex((prev) => prev + 1);
      }, 30); // tốc độ gõ chữ

      return () => clearTimeout(timeout);
    } else {
    }
  }, [index]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex >= ICTU_IMAGES.length - 1 ? 0 : prevIndex + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={cx('wrapper')}>
      <motion ref={ref} className={cx('container', { show: isOnScreen })}>
        <div className={cx('left')}>
          {ICTU_IMAGES.map((_, index) => (
            <Img key={index} className={cx({ show: index === currentIndex })} src={ICTU_IMAGES[index]?.image} />
          ))}
        </div>

        <div className={cx('right')}>
          <div className={cx('right-title')}>
            <div className={cx('title')}>Trường đại học CNTT & Truyền thông Thái Nguyên<span className={cx("line")}>:</span> <span>ICTU - Vì yêu mà đến</span></div>
          </div>

          <div className={cx('content')}>
            <p className={cx('text-content')}>{text}</p>
            <p className={cx('content-hide')}>{content}</p>
          </div>
          {/* Lớp “giữ chỗ”, ẩn đi nhưng vẫn chiếm diện tích */}
          <div className={cx('time')}>
            <FaLocationArrow />
            <div className={cx('time-text')}>
              {ICTU_IMAGES.map((_, index) => (
                <span key={index} className={cx({ show: index === currentIndex })}>
                  {ICTU_IMAGES[currentIndex].tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </motion>
    </div>
  );
}

export default NewsCard;
